<div class="space-y-6 text-text-primary pb-8">

      <!-- Header -->
      <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div>
                  <h1 class="text-xl font-bold tracking-tight mb-1">{{ 'brokerDashboard.settings.title' | translate }}</h1>
                  <p class="text-text-muted text-sm">{{ 'brokerDashboard.settings.subtitle' | translate }}</p>
            </div>
            <button (click)="save()" [disabled]="isSaving || isLoading"
                  class="flex items-center justify-center gap-2 px-6 py-3 bg-primary text-white text-sm font-bold rounded-xl shadow-primary-glow hover:bg-primary-hover transition-all disabled:opacity-60 disabled:cursor-not-allowed uppercase tracking-wider">
                  @if (isSaving) { <i class="fas fa-spinner fa-spin"></i> {{ 'brokerDashboard.settings.saving' | translate }} }
                  @else { <i class="fas fa-save"></i> {{ 'brokerDashboard.settings.saveChanges' | translate }} }
            </button>
      </div>

      <!-- Messages -->
      @if (successMessage) {
      <div class="flex items-center gap-3 px-6 py-4 bg-success-soft border border-success-border rounded-2xl text-success text-sm font-bold">
            <i class="fas fa-check-circle text-lg"></i><span>{{ successMessage }}</span>
      </div>
      }
      @if (errorMessage) {
      <div class="flex items-center gap-3 px-6 py-4 bg-danger-soft border border-danger-border rounded-2xl text-danger text-sm font-bold">
            <i class="fas fa-exclamation-circle text-lg"></i><span>{{ errorMessage }}</span>
      </div>
      }

      @if (isLoading) {
      <div class="space-y-6 animate-pulse">
            <div class="h-16 bg-surface-elevated border border-border rounded-2xl"></div>
            <div class="h-64 bg-surface-elevated border border-border rounded-2xl"></div>
      </div>
      } @else {

      <!-- Tabs Navigation -->
      <div class="flex gap-2 flex-wrap border-b border-border-subtle pb-4">
            @for (tab of [
            {id:'general', label:'brokerDashboard.settings.tabGeneral', icon:'fa-user-circle'},
            {id:'notifications', label:'brokerDashboard.settings.tabNotifications', icon:'fa-bell'},
            {id:'security', label:'brokerDashboard.settings.tabSecurity', icon:'fa-shield-alt'},
            {id:'business', label:'brokerDashboard.settings.tabBusiness', icon:'fa-briefcase'},
            {id:'crm', label:'brokerDashboard.settings.tabCrm', icon:'fa-handshake'}
            ]; track tab.id) {
            <button (click)="setTab(tab.id)"
                  class="flex items-center gap-2 px-5 py-3 text-sm transition-all rounded-xl font-bold uppercase tracking-wider"
                  [ngClass]="activeTab === tab.id ? 'bg-primary-soft text-primary shadow-sm border border-primary-border' : 'text-text-secondary hover:text-text-primary hover:bg-surface-hover'">
                  <i class="fas" [ngClass]="tab.icon"></i>
                  {{ tab.label | translate }}
            </button>
            }
      </div>

      <!-- General Settings Tab -->
      @if (activeTab === 'general') {
      <div class="bg-surface-elevated rounded-2xl border border-border shadow-subtle p-6">
            <div class="flex items-center gap-3 mb-6 pb-4 border-b border-border-subtle">
                  <div class="w-10 h-10 bg-primary-soft border border-primary-border rounded-xl flex items-center justify-center text-primary">
                        <i class="fas fa-user-circle"></i>
                  </div>
                  <h2 class="text-text-primary font-bold uppercase tracking-wider text-sm">{{ 'brokerDashboard.settings.tabGeneral' | translate }}</h2>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div class="space-y-2">
                        <label class="block text-xs font-bold text-text-secondary uppercase tracking-wider">{{ 'brokerDashboard.settings.firstName' | translate }}</label>
                        <input type="text" [(ngModel)]="settings.generalSettings.firstName"
                              class="w-full px-4 py-3 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition font-medium" />
                  </div>
                  <div class="space-y-2">
                        <label class="block text-xs font-bold text-text-secondary uppercase tracking-wider">{{ 'brokerDashboard.settings.lastName' | translate }}</label>
                        <input type="text" [(ngModel)]="settings.generalSettings.lastName"
                              class="w-full px-4 py-3 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition font-medium" />
                  </div>
                  <div class="space-y-2">
                        <label class="block text-xs font-bold text-text-secondary uppercase tracking-wider flex items-center justify-between">
                              {{ 'brokerDashboard.settings.email' | translate }}
                              <span class="text-[10px] text-text-muted">{{ 'brokerDashboard.settings.emailReadOnly' | translate }}</span>
                        </label>
                        <div class="relative">
                              <input type="email" [value]="settings.generalSettings.email" readonly
                                    class="w-full px-4 py-3 bg-surface border border-border-strong rounded-xl text-sm text-text-secondary cursor-not-allowed font-medium" />
                              <i class="fas fa-lock absolute right-4 top-1/2 -translate-y-1/2 text-text-muted text-xs"></i>
                        </div>
                  </div>
                  <div class="space-y-2">
                        <label class="block text-xs font-bold text-text-secondary uppercase tracking-wider">{{ 'brokerDashboard.settings.phoneNumber' | translate }}</label>
                        <input type="tel" [(ngModel)]="settings.generalSettings.phoneNumber"
                              class="w-full px-4 py-3 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition font-medium" />
                  </div>
                  <div class="space-y-2 md:col-span-2">
                        <label class="block text-xs font-bold text-text-secondary uppercase tracking-wider">{{ 'brokerDashboard.settings.language' | translate }}</label>
                        <select [(ngModel)]="settings.generalSettings.lang"
                              class="w-full px-4 py-3 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition font-medium">
                              <option value="en">{{ 'brokerDashboard.settings.langEnglish' | translate }}</option>
                              <option value="ar">{{ 'brokerDashboard.settings.langArabic' | translate }}</option>
                        </select>
                  </div>
            </div>
      </div>
      }

      <!-- Notifications Settings Tab -->
      @if (activeTab === 'notifications') {
      <div class="bg-surface-elevated rounded-2xl border border-border shadow-subtle p-6">
            <div class="flex items-center gap-3 mb-6 pb-4 border-b border-border-subtle">
                  <div class="w-10 h-10 bg-info-soft border border-info-border rounded-xl flex items-center justify-center text-info">
                        <i class="fas fa-bell"></i>
                  </div>
                  <h2 class="text-text-primary font-bold uppercase tracking-wider text-sm">{{ 'brokerDashboard.settings.tabNotifications' | translate }}</h2>
            </div>

            <div class="space-y-4">
                  <div class="flex items-center justify-between p-5 bg-surface border border-border rounded-xl hover:border-info-border transition-colors group">
                        <div class="flex-1 pr-6">
                              <h3 class="text-sm font-bold text-text-primary mb-1">{{ 'brokerDashboard.settings.emailNotifications' | translate }}</h3>
                              <p class="text-xs font-medium text-text-secondary">{{ 'brokerDashboard.settings.emailNotificationsDesc' | translate }}</p>
                        </div>
                        <label class="relative inline-flex items-center cursor-pointer shrink-0">
                              <input type="checkbox" [(ngModel)]="settings.notificationSettings.email" class="sr-only peer">
                              <div class="w-12 h-6 bg-surface-hover border border-border-strong rounded-full peer peer-checked:bg-info peer-checked:border-info after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-6"></div>
                        </label>
                  </div>
                  <div class="flex items-center justify-between p-5 bg-surface border border-border rounded-xl hover:border-info-border transition-colors group">
                        <div class="flex-1 pr-6">
                              <h3 class="text-sm font-bold text-text-primary mb-1">{{ 'brokerDashboard.settings.appNotifications' | translate }}</h3>
                              <p class="text-xs font-medium text-text-secondary">{{ 'brokerDashboard.settings.appNotificationsDesc' | translate }}</p>
                        </div>
                        <label class="relative inline-flex items-center cursor-pointer shrink-0">
                              <input type="checkbox" [(ngModel)]="settings.notificationSettings.app" class="sr-only peer">
                              <div class="w-12 h-6 bg-surface-hover border border-border-strong rounded-full peer peer-checked:bg-info peer-checked:border-info after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-6"></div>
                        </label>
                  </div>
            </div>
      </div>
      }

      <!-- Security Settings Tab -->
      @if (activeTab === 'security') {
      <div class="bg-surface-elevated rounded-2xl border border-border shadow-subtle p-6">
            <div class="flex items-center gap-3 mb-6 pb-4 border-b border-border-subtle">
                  <div class="w-10 h-10 bg-warning-soft border border-warning-border rounded-xl flex items-center justify-center text-warning">
                        <i class="fas fa-shield-alt"></i>
                  </div>
                  <h2 class="text-text-primary font-bold uppercase tracking-wider text-sm">{{ 'brokerDashboard.settings.tabSecurity' | translate }}</h2>
            </div>

            <div>
                  <h3 class="text-xs font-bold text-text-secondary uppercase tracking-wider mb-4">{{ 'brokerDashboard.settings.profileVisibility' | translate }}</h3>
                  <div class="space-y-3">
                        <label class="flex items-center p-4 bg-surface border border-border rounded-xl cursor-pointer hover:border-warning-border transition-colors"
                              [class.border-warning]="settings.securityPrivacy.showProfile === 'public'"
                              [class.bg-warning-soft]="settings.securityPrivacy.showProfile === 'public'">
                              <input type="radio" [(ngModel)]="settings.securityPrivacy.showProfile" value="public"
                                    class="w-4 h-4 text-warning bg-surface-input border-border focus:ring-warning">
                              <div class="ml-4 flex-1">
                                    <div class="text-sm font-bold text-text-primary mb-0.5">{{ 'brokerDashboard.settings.visibilityPublic' | translate }}</div>
                                    <div class="text-xs font-medium text-text-secondary">{{ 'brokerDashboard.settings.visibilityPublicDesc' | translate }}</div>
                              </div>
                        </label>
                        <label class="flex items-center p-4 bg-surface border border-border rounded-xl cursor-pointer hover:border-warning-border transition-colors"
                              [class.border-warning]="settings.securityPrivacy.showProfile === 'registered'"
                              [class.bg-warning-soft]="settings.securityPrivacy.showProfile === 'registered'">
                              <input type="radio" [(ngModel)]="settings.securityPrivacy.showProfile" value="registered"
                                    class="w-4 h-4 text-warning bg-surface-input border-border focus:ring-warning">
                              <div class="ml-4 flex-1">
                                    <div class="text-sm font-bold text-text-primary mb-0.5">{{ 'brokerDashboard.settings.visibilityRegistered' | translate }}</div>
                                    <div class="text-xs font-medium text-text-secondary">{{ 'brokerDashboard.settings.visibilityRegisteredDesc' | translate }}</div>
                              </div>
                        </label>
                        <label class="flex items-center p-4 bg-surface border border-border rounded-xl cursor-pointer hover:border-warning-border transition-colors"
                              [class.border-warning]="settings.securityPrivacy.showProfile === 'private'"
                              [class.bg-warning-soft]="settings.securityPrivacy.showProfile === 'private'">
                              <input type="radio" [(ngModel)]="settings.securityPrivacy.showProfile" value="private"
                                    class="w-4 h-4 text-warning bg-surface-input border-border focus:ring-warning">
                              <div class="ml-4 flex-1">
                                    <div class="text-sm font-bold text-text-primary mb-0.5">{{ 'brokerDashboard.settings.visibilityPrivate' | translate }}</div>
                                    <div class="text-xs font-medium text-text-secondary">{{ 'brokerDashboard.settings.visibilityPrivateDesc' | translate }}</div>
                              </div>
                        </label>
                  </div>
            </div>
      </div>
      }

      <!-- Business Settings Tab -->
      @if (activeTab === 'business') {
      <div class="bg-surface-elevated rounded-2xl border border-border shadow-subtle p-6">
            <div class="flex items-center gap-3 mb-6 pb-4 border-b border-border-subtle">
                  <div class="w-10 h-10 bg-primary-soft border border-primary-border rounded-xl flex items-center justify-center text-primary">
                        <i class="fas fa-briefcase"></i>
                  </div>
                  <h2 class="text-text-primary font-bold uppercase tracking-wider text-sm">{{ 'brokerDashboard.settings.tabBusiness' | translate }}</h2>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div class="space-y-2 md:col-span-2">
                        <label class="block text-xs font-bold text-text-secondary uppercase tracking-wider">{{ 'brokerDashboard.settings.companyName' | translate }}</label>
                        <input type="text" [(ngModel)]="settings.businessSettings.companyName"
                              class="w-full px-4 py-3 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition font-medium" />
                  </div>
                  <div class="space-y-2 md:col-span-2">
                        <label class="block text-xs font-bold text-text-secondary uppercase tracking-wider flex items-center justify-between">
                              {{ 'brokerDashboard.settings.commercialRegisterNumber' | translate }}
                              <span class="text-[10px] text-text-muted">{{ 'brokerDashboard.settings.emailReadOnly' | translate }}</span>
                        </label>
                        <div class="relative">
                              <input type="text" [value]="settings.businessSettings.commercialRegisterNumber" readonly
                                    class="w-full px-4 py-3 bg-surface border border-border-strong rounded-xl text-sm text-text-secondary cursor-not-allowed font-medium" />
                              <i class="fas fa-lock absolute right-4 top-1/2 -translate-y-1/2 text-text-muted text-xs"></i>
                        </div>
                  </div>
                  <div class="space-y-2">
                        <label class="block text-xs font-bold text-text-secondary uppercase tracking-wider">{{ 'brokerDashboard.settings.yearsOfExperience' | translate }}</label>
                        <input type="number" [(ngModel)]="settings.businessSettings.yearsOfExperience" min="0"
                              class="w-full px-4 py-3 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition font-medium" />
                  </div>
                  <div class="space-y-2">
                        <label class="block text-xs font-bold text-text-secondary uppercase tracking-wider">{{ 'brokerDashboard.settings.specialization' | translate }}</label>
                        <select [(ngModel)]="settings.businessSettings.specialization"
                              class="w-full px-4 py-3 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition font-medium">
                              <option value="both" class="bg-surface text-text-primary">{{ 'brokerDashboard.settings.specBoth' | translate }}</option>
                              <option value="commercial" class="bg-surface text-text-primary">{{ 'brokerDashboard.settings.specCommercial' | translate }}</option>
                              <option value="residential" class="bg-surface text-text-primary">{{ 'brokerDashboard.settings.specResidential' | translate }}</option>
                        </select>
                  </div>
            </div>
      </div>
      }

      <!-- CRM Settings Tab -->
      @if (activeTab === 'crm') {
      <div class="bg-surface-elevated rounded-2xl border border-border shadow-subtle p-6">
            <div class="flex items-center gap-3 mb-6 pb-4 border-b border-border-subtle">
                  <div class="w-10 h-10 bg-success-soft border border-success-border rounded-xl flex items-center justify-center text-success">
                        <i class="fas fa-handshake"></i>
                  </div>
                  <h2 class="text-text-primary font-bold uppercase tracking-wider text-sm">{{ 'brokerDashboard.settings.tabCrm' | translate }}</h2>
            </div>

            <div class="flex items-center justify-between p-5 bg-surface border border-border rounded-xl hover:border-success-border transition-colors group mb-4">
                  <div class="flex-1 pr-6">
                        <h3 class="text-sm font-bold text-text-primary mb-1">{{ 'brokerDashboard.settings.enableCrm' | translate }}</h3>
                        <p class="text-xs font-medium text-text-secondary">{{ 'brokerDashboard.settings.enableCrmDesc' | translate }}</p>
                  </div>
                  <label class="relative inline-flex items-center cursor-pointer shrink-0">
                        <input type="checkbox" [(ngModel)]="settings.crmSettings.enabled" class="sr-only peer">
                        <div class="w-12 h-6 bg-surface-hover border border-border-strong rounded-full peer peer-checked:bg-success peer-checked:border-success after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-6"></div>
                  </label>
            </div>

            @if (settings.crmSettings.enabled) {
            <div class="p-5 bg-success-soft/20 border border-success-border rounded-xl flex items-center gap-3">
                  <i class="fas fa-check-circle text-success text-xl"></i>
                  <p class="text-sm font-bold text-success">{{ 'brokerDashboard.settings.crmEnabled' | translate }}</p>
            </div>
            }
      </div>
      }

      }

</div>